
import { useState, useEffect } from "react";
import { AuthDialog } from "./AuthDialog";

type AuthMode = "signin" | "signup" | "magic-link";

interface AuthFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
  defaultMode?: AuthMode;
  redirectPath?: string;
}

export function AuthForm({ 
  open, 
  onOpenChange, 
  onSuccess, 
  defaultMode = "signup", 
  redirectPath 
}: AuthFormProps) {
  const [mode, setMode] = useState<AuthMode>(defaultMode);
  
  // Update mode when defaultMode prop changes
  useEffect(() => {
    if (defaultMode) {
      setMode(defaultMode);
    }
  }, [defaultMode]);

  return (
    <AuthDialog
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      mode={mode}
      onModeChange={setMode}
      redirectPath={redirectPath}
    />
  );
}
